import { render, staticRenderFns } from "./registList.vue?vue&type=template&id=775ee364&scoped=true"
import script from "./registList.vue?vue&type=script&lang=js"
export * from "./registList.vue?vue&type=script&lang=js"
import style0 from "./registList.vue?vue&type=style&index=0&id=775ee364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ee364",
  null
  
)

export default component.exports